export const preSeed = 1;
export const seed = 2;
export const seriesA = 3;
export const seriesB = 4;
